module.exports = __webpack_public_path__ + "static/img/0d2a60c4-af07-47dd-8947-d5bbe64ec237.b76c213e.png";